import { Link } from "react-router-dom";
import noticias from "../data/noticias";

const Noticias = () => {
  return (
    <div className="container mx-auto py-10 px-4">
      <h1 className="text-3xl font-bold text-center mb-8 uppercase text-[#202C5A]">
        Todas las noticias
      </h1>
      <div className="grid md:grid-cols-3 gap-6">
        {noticias.slice().reverse().map((nota) => (
          <Link
            to={`/noticias/${nota.id}`}
            key={nota.id}
            className="block rounded overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <img
              src={nota.imagen}
              alt={nota.titulo}
              className="w-full h-60 object-cover"
            />
            <div className="p-4">
              <span className="block text-sm text-gray-500 mb-1">
                {nota.categoria} - {nota.fecha}
              </span>
              <h3 className="text-xl font-bold text-[#202C5A]">{nota.titulo}</h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Noticias;
